import { Component, EventEmitter, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as LocaleList from "@centiro/locale-list";

import { NgLocaleService } from "@centiro/ng-locale";
import { LanguageChangeService } from "../../services/language-change.service";
import { SpinnerService } from "../../services/spinner.service";

// Provides the Angular API to register locale data for formatting dates, numbers, and currencies
import { registerLocaleData } from '@angular/common';

// Locales not pre-registered in Angular must be statically imported
import pl from '@angular/common/locales/pl';

export const FallbackLocales: Record<string, { base: string; data: any }> = {
  'pl-PL': { base: 'pl', data: pl }, // Languages not available in Angular's registered locales should be added here
};

@Component({
  selector: "app-select-language",
  template: `
    <select #langSelect (change)="changeLanguage(langSelect.value)">
      <option
        *ngFor="let lang of locales"
        [value]="lang.code"
        [attr.selected]="lang.code === translate.currentLang ? '' : null"
        >{{ ("languagelist." + lang.language | customTranslatePipe) | async }} - {{ ("languagelist." + lang.location | customTranslatePipe) | async }}</option
      >
    </select>
  `,
  styles: [
    "select{ border:none ; font-weight:600;background-color: rgba(0, 0, 0, 0); color: var(--color-header-text);}",
    "option{ color: rgba(0, 0, 0, 1) !important}",
  ],
})

export class SelectLanguageComponent {
  locales: any;
  @Output() localeChange: EventEmitter<any> = new EventEmitter();
  constructor(
    public translate: TranslateService,
    private localeService: NgLocaleService,
    private changeDispatcher: LanguageChangeService,
    private spinnerService: SpinnerService
  ) {
    this.locales = LocaleList.getByLocaleCodes(this.translate.getLangs());
    this.locales= this.locales.filter(language=>language.location !== null); //filter languages with no location

    this.localeService.registerCulture(this.translate.currentLang).then(() => {
      this.localeChange.emit();
    });
    }

  async changeLanguage(lang: string) {
    this.spinnerService.show();
    this.translate.use(lang);
    this.changeDispatcher.changeLanguage(lang);

    if (!LocaleList.validate(lang)) {
      console.warn("Invalid locale:", lang);
      this.spinnerService.hide();
      return;
    }

    try {
      // First, try the internal library registration
      await this.localeService.registerCulture(lang);
    } catch (err) {
      console.warn(`Locale "${lang}" failed to load via library. Checking fallback.`);

      // If library registration fails, attempt a static fallback
      const fallback = FallbackLocales[lang];

      if (fallback) {
        try {
          registerLocaleData(fallback.data, lang);
          console.info(`Fallback: registered static base locale "${fallback.base}" for "${lang}"`);
        } catch (fallbackErr) {
          console.error(`Failed to register fallback for "${lang}"`, fallbackErr);
        }
      }
    } finally {
      this.localeChange.emit();
      this.spinnerService.hide();
    }
  }

}
